import type { Novidade } from './tipos';

/** Fase 2, W30: WhatsApp com três provedores (API oficial, Baileys e whatsmeow), escolhido por workspace. */
export const novidadeWhatsAppProvedores: Novidade = {
  id: '2026-10-05-whatsapp-provedores',
  publicada_em: '2026-10-05',
  tipo: 'novo',
  modulo: 'integracoes',
  permissao: 'integracoes.conectores',
  textos: {
    pt: {
      titulo: 'WhatsApp: três formas de conectar',
      resumo: 'Além da API oficial da Meta (a recomendada), o número pode ser pareado pelo QR com Baileys ou whatsmeow.',
      passos: [
        'Em Integrações, Conectores, os três cartões de WhatsApp ficam lado a lado. Um número por workspace: desconecte o atual antes de trocar.',
        'Baileys e whatsmeow são não oficiais: o número pode ser bloqueado pelo WhatsApp. Leia o aviso do cartão antes de parear.',
        'Clique em Parear e leia o QR no celular, em Aparelhos conectados, ou gere o código pelo número.',
        'Sem template e sem a janela de 24 h, mas com limite de envios por minuto, que você ajusta em Ritmo de envio.',
      ],
    },
    en: {
      titulo: 'WhatsApp: three ways to connect',
      resumo: 'Besides Meta\'s official API (the recommended one), the number can be paired by QR with Baileys or whatsmeow.',
      passos: [
        'In Integrations, Connectors, the three WhatsApp cards sit side by side. One number per workspace: disconnect the current one before switching.',
        'Baileys and whatsmeow are unofficial: WhatsApp may block the number. Read the card warning before pairing.',
        'Click Pair and scan the QR on the phone, under Linked devices, or generate the code from the number.',
        'No templates and no 24-hour window, but with a per-minute sending limit that you adjust in Sending pace.',
      ],
    },
    es: {
      titulo: 'WhatsApp: tres formas de conectar',
      resumo: 'Además de la API oficial de Meta (la recomendada), el número se puede vincular por QR con Baileys o whatsmeow.',
      passos: [
        'En Integraciones, Conectores, las tres tarjetas de WhatsApp quedan lado a lado. Un número por espacio: desconecta el actual antes de cambiar.',
        'Baileys y whatsmeow no son oficiales: WhatsApp puede bloquear el número. Lee el aviso de la tarjeta antes de vincular.',
        'Haz clic en Vincular y lee el QR en el celular, en Dispositivos vinculados, o genera el código con el número.',
        'Sin plantilla y sin la ventana de 24 h, pero con límite de envíos por minuto, que ajustas en Ritmo de envío.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-whatsapp-provedores/cartoes.webp', null, '/novidades/2026-10-05-whatsapp-provedores/pareamento.webp', null],
  treinamento: { curso: 'novidades' },
  rota: '/integracoes/integracoes/conectores',
};
